import { INSTANCE_NAMES, getInstance } from '@retail/single-instance-cache';

import { UserConfigurationModel } from './userConfigurationModel';

/** @deprecated access and mutate the user configuration through useDeprecatedUserConfiguration() */
export function getUserConfiguration() {
    return getInstance(INSTANCE_NAMES.USER_CONFIGURATION, new UserConfigurationModel());
}
